let metaToggles = document.querySelectorAll(".meta-toggle");
let toggles = document.querySelectorAll(".meta-toggle .toggle");
toggles.forEach((toggle) => {
    toggle.addEventListener("click", function () {
        let parentMeta = toggle.closest(".meta-toggle");
        let isOpened = false;
        if (parentMeta.classList.contains("expanded")) {
            isOpened = true;
        }
        metaToggles.forEach((meta) => {
            meta.classList.remove("expanded");
        });

        if (!isOpened) {
            parentMeta.classList.add("expanded");
        }
    });
});
